import { render } from "./Pwa_Install_Prompt.vue?vue&type=template&id=0b33352f&scoped=true"
import script from "./Pwa_Install_Prompt.vue?vue&type=script&lang=js"
export * from "./Pwa_Install_Prompt.vue?vue&type=script&lang=js"

import "./Pwa_Install_Prompt.vue?vue&type=style&index=0&id=0b33352f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b33352f"]])

export default __exports__